import { Action } from '@ngrx/store';


export enum AccesoActionTypes {
	SidebarToggleRequested = "[Header Component] Sidebar Toggle Requested",
	SidebarCollapseRequested = "[Header Component] Sidebar Collapse Requested",
	AplicacionesFavsToggleRequested = "[MainApp Component] Aplicaciones Favs Toggle Requested",
	EmailsFavsToggleRequested = "[MainEmail Component] Emails Favs Toggle Requested",
	ReportesToggleRequested = "[Report Component] Report Toggle Requested",
	BasesConocimientoToggleRequested = "[OtherApp Component] OtherApp Toggle Requested"
}

export class SidebarToggleRequested implements Action {
	readonly type: string = AccesoActionTypes.SidebarToggleRequested;
	constructor() {
	}
}

export class SidebarCollapseRequested implements Action {
	readonly type: string = AccesoActionTypes.SidebarCollapseRequested;
	constructor() {
	}
}

export class AplicacionesFavsToggleRequested implements Action {
	readonly type: string = AccesoActionTypes.AplicacionesFavsToggleRequested;
	constructor() {
	}
}

export class EmailsFavsToggleRequested implements Action {
	readonly type: string = AccesoActionTypes.EmailsFavsToggleRequested;
	constructor() {
	}
}

export class ReportesToggleRequested implements Action {
	readonly type: string = AccesoActionTypes.ReportesToggleRequested;
	constructor() {
	}
}

export class BasesConocimientoToggleRequested implements Action {
	readonly type: string = AccesoActionTypes.BasesConocimientoToggleRequested;
	constructor() {
	}
}


export type AccesoActions = SidebarToggleRequested | SidebarCollapseRequested |
	AplicacionesFavsToggleRequested | EmailsFavsToggleRequested |
	ReportesToggleRequested | BasesConocimientoToggleRequested;


